import { render, staticRenderFns } from "./tab-details-edit.html?vue&type=template&id=3453f5b7&scoped=true&"
import script from "./tab-details-edit.js?vue&type=script&lang=js&"
export * from "./tab-details-edit.js?vue&type=script&lang=js&"
import style0 from "./tab-details-edit.scss?vue&type=style&index=0&id=3453f5b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453f5b7",
  null
  
)

export default component.exports